import { DataSource, Layout } from "@mcleod/components";
import { AgenciesWithPrimary } from "../../../general/src/AgenciesWithPrimary";

export abstract class AutogenLayoutLocationUsers extends Layout {
    agenciesWithPrimary: AgenciesWithPrimary;
    sourceAgencyLink: DataSource;
    sourceLocation: DataSource;
}
